export default "__VITE_ASSET__52b4500b__"